import {TrustStatus} from '@sollapay/enums';

/** The list's status groups in display order: active first, then the setup statuses in lifecycle order. */
export const TRUST_STATUS_GROUP_ORDER = [
  TrustStatus.TRUST_ACTIVE,
  TrustStatus.SETUP_IN_PROGRESS,
  TrustStatus.PENDING_VALIDATION,
  TrustStatus.IN_REVIEW,
  TrustStatus.CLARIFICATION_REQUIRED,
  TrustStatus.ACTIVATION_PENDING
] as const satisfies readonly TrustStatus[];

export interface TrustStatusGroup<T> {
  status: TrustStatus;
  items: T[];
}

/** Which status groups the reader folded; one fold state drives both the table and the card grid. */
export interface TrustAccountGroupFold {
  isCollapsed: (status: TrustStatus) => boolean;
  toggle: (status: TrustStatus) => void;
}

/** Non-empty groups in display order; items keep their relative (sorted) order within a group. */
export function groupByTrustStatus<T extends {trustStatus: TrustStatus}>(
  items: readonly T[]
): TrustStatusGroup<T>[] {
  return TRUST_STATUS_GROUP_ORDER.map(status => ({
    status,
    items: items.filter(item => item.trustStatus === status)
  })).filter(group => group.items.length > 0);
}
